import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassActions extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassActions'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: '',
      standardActionId: null,
      isAccepted: false,
      isParked: true,
      position: 0,
      subCategoryId: null,
      title: '',
      description: '',
      pin: null,
      guestId: null,
      rating: null,
    }
  }
}
const servicePath = 'compass-actions'
const servicePlugin = makeServicePlugin({
  Model: CompassActions,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
